import { AutogenModelEdiDriverextrapay, AutogenRowEdiDriverextrapay } from "./autogen/AutogenModelEdiDriverextrapay";

export class ModelEdiDriverextrapay extends AutogenModelEdiDriverextrapay<RowEdiDriverextrapay> {
    constructor() {
        super(RowEdiDriverextrapay);
    }
}

export class RowEdiDriverextrapay extends AutogenRowEdiDriverextrapay {
}